import React from 'react';
import './Loader.css';
import { ColorRing } from 'react-loader-spinner';

const Loader = () => {
  return (
    <div className="loader-container d-flex justify-content-center align-items-center">
    <ColorRing
  visible={true}
  height="80"
  width="80"
  ariaLabel="color-ring-loading"
  wrapperStyle={{}}
  wrapperClass="color-ring-wrapper"
  colors={['#c22627', '#c22627', '#c22627', '#c22627', '#c22627']}
/>
    </div>
  );
};

export default Loader;
